import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "channel-container w-full" }
const _hoisted_2 = { class: "row w-full mtop-08" }
const _hoisted_3 = { class: "col-0-8 colend mright-04" }
const _hoisted_4 = { class: "main-m font-m" }
const _hoisted_5 = { class: "main-m font-m" }
const _hoisted_6 = { class: "row w-full mtop-10" }
const _hoisted_7 = { class: "col-0-8 colend mright-04" }
const _hoisted_8 = { class: "main-m font-m" }
const _hoisted_9 = {
  key: 0,
  class: "w-full"
}
const _hoisted_10 = { class: "row w-full mtop-10" }
const _hoisted_11 = { class: "col-0-8 colend mright-04" }
const _hoisted_12 = { class: "main-m font-m" }
const _hoisted_13 = {
  key: 0,
  class: "row w-full mtop-10"
}
const _hoisted_14 = { class: "main-m" }
const _hoisted_15 = { class: "row w-full mtop-10" }
const _hoisted_16 = { class: "col-0-8 colend mright-04" }
const _hoisted_17 = { class: "main-m font-m" }
const _hoisted_18 = {
  key: 1,
  class: "row w-full mtop-10"
}
const _hoisted_19 = { class: "main-m" }
const _hoisted_20 = {
  key: 2,
  class: "row-end mtop-10 mbottom-05"
}

import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { FinancialChannelResponse, AddOrUpdateFinancialChannelRequest } from '@/apiGenerate/medserver';
import InputText from 'primevue/inputtext';
import ToggleSwitch from 'primevue/toggleswitch';
import { FinancialChannelType } from '@/models/accounting.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'esFinancialChannelSettings',
  props: {
    financialChannel: {},
    isOwner: { type: Boolean, default: false }
  },
  emits: ['updateChannel', 'updateActiveChannel'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const addOrUpdateFinancialChannelRequest = ref<AddOrUpdateFinancialChannelRequest>({
    title: props.financialChannel.title,
    type: props.financialChannel.type,
    active: props.financialChannel.active,
    bankAccounts: {
        iban: props.financialChannel.bankAccounts?.iban,
        bic:  props.financialChannel.bankAccounts?.bic,
        active: props.financialChannel.bankAccounts?.active,
        editable: props.financialChannel.bankAccounts?.editable,
        id: props.financialChannel.bankAccounts?.id
    }
});

const emits = __emit;

const confirmDisabled = computed(() => {
    return !addOrUpdateFinancialChannelRequest.value.active || !addOrUpdateFinancialChannelRequest.value.bankAccounts?.bic || !addOrUpdateFinancialChannelRequest.value.bankAccounts?.iban
});

const bankFormDisabled = computed(() => {
    return !props.isOwner || !addOrUpdateFinancialChannelRequest.value.bankAccounts.editable || !addOrUpdateFinancialChannelRequest.value.active;
})

const bankAccountEditable = () => {
    return addOrUpdateFinancialChannelRequest.value.bankAccounts.editable;
}
 
watch(
    () => props.financialChannel,
    () => {
        if (props.financialChannel) {
            addOrUpdateFinancialChannelRequest.value = {
                title: props.financialChannel.title,
                type: props.financialChannel.type,
                active: props.financialChannel.active,
                bankAccounts: {
                    iban: props.financialChannel.bankAccounts?.iban,
                    bic:  props.financialChannel.bankAccounts?.bic,
                    active: props.financialChannel.bankAccounts?.active,
                    editable: props.financialChannel.bankAccounts?.editable,
                    id: props.financialChannel.bankAccounts?.id
                }
            }
        }
    }
)


return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.data.type')), 1)
      ]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)(`settings.label.accounting.financialGroup.financialChannel.type.${addOrUpdateFinancialChannelRequest.value.type}`)), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.data.active')), 1)
      ]),
      _createVNode(_unref(ToggleSwitch), {
        disabled: !_ctx.isOwner,
        modelValue: addOrUpdateFinancialChannelRequest.value.active,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addOrUpdateFinancialChannelRequest.value.active) = $event)),
        onValueChange: _cache[1] || (_cache[1] = ($event: any) => (emits('updateActiveChannel')))
      }, null, 8, ["disabled", "modelValue"])
    ]),
    (_unref(FinancialChannelType).BankAccount === addOrUpdateFinancialChannelRequest.value.type)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "rod-horizontal" }, null, -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.data.bank.bic')), 1)
            ]),
            _createVNode(_unref(InputText), {
              invalid: addOrUpdateFinancialChannelRequest.value.active && (!addOrUpdateFinancialChannelRequest.value.bankAccounts?.bic || addOrUpdateFinancialChannelRequest.value.bankAccounts.bic.length === 0),
              type: "text",
              size: "small",
              modelValue: addOrUpdateFinancialChannelRequest.value.bankAccounts.bic,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addOrUpdateFinancialChannelRequest.value.bankAccounts.bic) = $event)),
              class: "w-full",
              disabled: bankFormDisabled.value
            }, null, 8, ["invalid", "modelValue", "disabled"])
          ]),
          (addOrUpdateFinancialChannelRequest.value.active && (!addOrUpdateFinancialChannelRequest.value.bankAccounts?.bic || addOrUpdateFinancialChannelRequest.value.bankAccounts.bic.length === 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-0-8 mright-04" }, null, -1)),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.error.missingIban')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.data.bank.iban')), 1)
            ]),
            _createVNode(_unref(InputText), {
              invalid: addOrUpdateFinancialChannelRequest.value.active && (!addOrUpdateFinancialChannelRequest.value.bankAccounts?.iban || addOrUpdateFinancialChannelRequest.value.bankAccounts.iban.length === 0),
              type: "text",
              size: "small",
              modelValue: addOrUpdateFinancialChannelRequest.value.bankAccounts.iban,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addOrUpdateFinancialChannelRequest.value.bankAccounts.iban) = $event)),
              class: "w-full",
              disabled: bankFormDisabled.value
            }, null, 8, ["invalid", "modelValue", "disabled"])
          ]),
          (addOrUpdateFinancialChannelRequest.value.active && (!addOrUpdateFinancialChannelRequest.value.bankAccounts?.iban || addOrUpdateFinancialChannelRequest.value.bankAccounts.iban.length === 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-0-8 mright-04" }, null, -1)),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.error.missingIban')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isOwner && bankAccountEditable())
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_es_button, {
                  disabled: confirmDisabled.value,
                  label: _unref(t)('action.save'),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('updateChannel', addOrUpdateFinancialChannelRequest.value))),
                  "is-primary": true
                }, null, 8, ["disabled", "label"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})